interface Props {
  color?: string;
}

const CartIcon: React.FC<Props> = ({ color = "#0D0C21" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.41602 1.99609L1.00391 2.01367L1.01368 4.01367L3.08399 4.0039L6.37891 11.9082L5.18164 13.8223C4.34328 15.161 5.36268 17 6.94141 17H19V15H6.94141C6.83014 15 6.81731 14.9781 6.87696 14.8828L8.05274 13H15.5215C16.2475 13 16.9175 12.6057 17.2695 11.9707L20.8711 5.48436C21.2421 4.81836 20.7601 3.99999 19.9981 3.99999H5.25L4.41602 1.99609ZM7 18C5.89543 18 5 18.8954 5 20C5 21.1046 5.89543 22 7 22C8.10457 22 9 21.1046 9 20C9 18.8954 8.10457 18 7 18ZM17 18C15.8954 18 15 18.8954 15 20C15 21.1046 15.8954 22 17 22C18.1046 22 19 21.1046 19 20C19 18.8954 18.1046 18 17 18Z"
        fill={color}
      />
    </svg>
  );
};

export default CartIcon;
